module.exports = __webpack_public_path__ + "static/media/sortDarkSvg.14910a07.svg";